import { useIntl } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';
import { Alert, Button } from '@rossum/ui/material';
import { basePath, engineBasicSettingsPath } from '../routes';

type EngineErrorProps = {
  engineId?: number;
};

export const EngineErrorAlert = ({ engineId }: EngineErrorProps) => {
  const intl = useIntl();

  const id = `features.engines.error.${
    engineId ? ('fieldError' as const) : ('engineError' as const)
  }` as const;

  return (
    <Alert
      variant="outlined"
      color="error"
      sx={{ my: 4 }}
      action={
        <Button
          component={RouterLink}
          color="inherit"
          to={engineId ? engineBasicSettingsPath(engineId) : basePath}
        >
          {intl.formatMessage({ id: 'features.engines.error.back' })}
        </Button>
      }
    >
      {intl.formatMessage({ id })}
    </Alert>
  );
};
